import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/api';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { MapPin, CurrencyEur } from '@phosphor-icons/react';

export const ProOnboardingBanner = () => {
  const [state, setState] = useState(null);

  useEffect(() => {
    api.get('/api/professionals/me/onboarding').then((r) => setState(r.data)).catch(() => {});
  }, []);

  if (!state || (!state.needs_coverage && !state.needs_tariff)) return null;

  return (
    <div className="space-y-3 mb-6" data-testid="pro-onboarding-banner">
      {state.needs_coverage && (
        <Card className="p-4 rounded-2xl border-amber-300 bg-amber-50" data-testid="onboarding-coverage">
          <div className="flex items-start gap-3 flex-wrap">
            <MapPin size={22} weight="duotone" className="text-amber-700 mt-0.5" />
            <div className="flex-1 min-w-[240px]">
              <div className="font-semibold text-sm mb-1">Imposta la tua zona di copertura</div>
              <p className="text-xs text-amber-900">
                Seleziona sulla mappa i CAP in cui operi: senza copertura le richieste dei clienti non
                possono esserti smistate.
              </p>
            </div>
            <Link to="/professional/copertura">
              <Button size="sm" className="rounded-full h-8" data-testid="onboarding-coverage-btn">Apri la mappa</Button>
            </Link>
          </div>
        </Card>
      )}
      {state.needs_tariff && (
        <Card className="p-4 rounded-2xl border-sky-300 bg-sky-50" data-testid="onboarding-tariff">
          <div className="flex items-start gap-3 flex-wrap">
            <CurrencyEur size={22} weight="duotone" className="text-sky-700 mt-0.5" />
            <div className="flex-1 min-w-[240px]">
              <div className="font-semibold text-sm mb-1">Crea il tuo tariffario</div>
              <p className="text-xs text-sky-900">
                Indica le tipologie di prestazioni che svolgi e il relativo prezzo: i clienti vedranno
                la tua offerta e potranno sceglierti.
              </p>
            </div>
            <Link to="/professional/prestazioni">
              <Button size="sm" className="rounded-full h-8" data-testid="onboarding-tariff-btn">Crea il tariffario</Button>
            </Link>
          </div>
        </Card>
      )}
    </div>
  );
};

export default ProOnboardingBanner;
